// Adapted from D:/AI/site-thebutler/src/main.tsx
import './styles/index.css';
import { ViteReactSSG } from 'vite-react-ssg';
import routes from './router/config';

export const createRoot = ViteReactSSG({
  routes,
  basename: __BASE_PATH__,
});
